// extracted by mini-css-extract-plugin
module.exports = {"header":"PaymentHeader_header__PGCoE"};